export const NAME = 'proposals';
